import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Language } from "../Entities/Language/Language";
import { LanguageInterface } from "../Entities/Language/LanguageInterface";

class LanguageFactory extends Factory implements FactoryInterface {

  public create(data: any): LanguageInterface {
    return new Language({
      iso: data.iso
    });
  }

  public reinitialize(data: any): LanguageInterface {
    return new Language({
      ...data
    });
  }
}

export default new LanguageFactory();
